import { datadogLogs } from '@datadog/browser-logs';

export function programsContainDegreeOffering(programs) {
  return programs.some((program) => program.degreeOffering);
}

export function getDataFromPrograms(programs) {
  if (programs.length > 1) {
    datadogLogs.logger.log(`Grouping has more than one program, selecting salesforce org from ${JSON.stringify(programs[0])}`);
  }

  const singleProgramData = {
    salesforceOrg: programs[0].salesforceOrg ? programs[0].salesforceOrg : '',
    programId: programs[0].programId ? programs[0].programId : '',
  };
  return singleProgramData;
}

export const getCredentialTypesFromProgramsOfStudy = (programsOfStudy, credentialTypes) => {
  let multipleCredentialTypesFound = false;
  let singleCredentialType;
  programsOfStudy.forEach((pos) => {
    if (!singleCredentialType) {
      singleCredentialType = pos.credential_type_id;
    } else if (singleCredentialType !== pos.credential_type_id) {
      multipleCredentialTypesFound = true;
      datadogLogs.logger.log(`Multiple Credential Types Found:, ${multipleCredentialTypesFound}, ${JSON.stringify(programsOfStudy)}`);
    }
  });

  const availableCredentialTypes = [];
  const found = credentialTypes.find((credType) => credType.id === singleCredentialType) || {};
  availableCredentialTypes.push(found);
  return availableCredentialTypes;
};
